import PropTypes from 'prop-types';

const BookingNotePropTypes = PropTypes.shape({
  id: PropTypes.string,
  // used only in booking
  bookingID: PropTypes.string,
  // used only in opportunity
  parentType: PropTypes.string,
  parentID: PropTypes.string,
  note: PropTypes.string,
  privacy: PropTypes.string,
  muName: PropTypes.string,
  muPreferredName: PropTypes.string,
  muIsAgent: PropTypes.bool,
  muAwsID: PropTypes.string,
  muID: PropTypes.number,
  muAffiliateID: PropTypes.number,
  muAffiliateCompanyBranchID: PropTypes.number,
  muAffiliateCompanyBranchShortName: PropTypes.string,
  muCompanyID: PropTypes.number,
  deletedAt: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
});

const BookingNoteDefault = () => Object.assign({}, {
  id: '',
  bookingID: '',
  parentType: '',
  parentID: '',
  note: '',
  privacy: '',
  muName: '',
  muPreferredName: '',
  muIsAgent: false,
  muAwsID: '',
  muID: 0,
  muAffiliateID: 0,
  muAffiliateCompanyBranchID: 0,
  muAffiliateCompanyBranchShortName: '',
  muCompanyID: 0,
  deletedAt: '',
  createdAt: '',
  updatedAt: '',
});

export default BookingNotePropTypes;
export { BookingNoteDefault };




// WEBPACK FOOTER //
// ./src/types/BookingNote.jsx